import { BrowserRouter, Route, Routes, Navigate,HashRouter } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from './global';

//Paginas
import Login from '../pages/Login';
import Main from '../pages/Main';
import PrimeiroAcesso from '../pages/PrimeiroAcesso';
import Verificacao from '../pages/Verificacao';
import CriarSenha from '../pages/CriarSenha';
import EsqueciSenha from '../pages/esquecisenha';
import SucessoSenha from '../pages/SucessoSenha';
import ErroAcesso from '../pages/ErroAcesso';
import Pedidos from '../pages/Pedidos';
import DetPedido from '../pages/DetPedido';
import Financeiro from '../pages/Financeiro';

import Contatos from '../pages/Contatos';
import Empresa from '../pages/empresa';
import Avaliacao from '../pages/Avaliacao';
import Assistencia from '../pages/Assistencia';
import DetAssistencias from '../pages/DetAssistencias';

import NewPedido from '../pages/NewPedido';

//Catalogo
import HomeCatalogo from '../catalogo/pages/Home';
import MenuCatalogo from '../catalogo/pages/Menu';
import ProdutosCatalogo from '../catalogo/pages/Produtos';


const Rotas = () => {
   const { logado } = useContext(AuthContext);
   const { status } = useContext(AuthContext);

   function SecureRotas({ children }) {
      if (!logado) {
         return <Navigate to="/" replace />
      } else {
         return children
      }
   }

   function SecureAcesso({ children }) {
      if (status==='acesso') {
         return children
      } else {
         return <Navigate to="/" replace />
      }
   }

   function SecureEsqueci({ children }) {
      if (status==='esqueci') {
         return children
      } else {
         return <Navigate to="/" replace />
      }
   }

   function SecureVerifica({ children }) {
      if (status==='verifica') {
         return children
      } else {
         return <Navigate to="/" replace />
      }
   }

   function SecureCriarSenha({ children }) {
      if (status==='criarsenha') {
         return children
      } else {
         return <Navigate to="/" replace />
      }
   }

   function SecureSucesso({ children }) {
      if (status==='sucesso') {
         return children
      } else {
         return <Navigate to="/" replace />
      }
   }

   function SecureErro({ children }) {
      if (status==='erro') {
         return children
      } else {
         return <Navigate to="/" replace />
      }
   }

   return (
      <HashRouter>
         <Routes>
            <Route path="/" element={<Login />} exact />
            <Route path="/Acesso" element={<SecureAcesso><PrimeiroAcesso /></SecureAcesso>} exact />
            <Route path="/Esqueci" element={<SecureEsqueci><EsqueciSenha /></SecureEsqueci>} exact />
            <Route path="/Verificacao" element={<SecureVerifica><Verificacao /></SecureVerifica>} exact />
            <Route path="/Criarsenha" element={<SecureCriarSenha><CriarSenha /></SecureCriarSenha>} exact />
            <Route path="/Sucessosenha" element={<SecureSucesso><SucessoSenha /></SecureSucesso>} exact />
            <Route path="/Erroacesso" element={<SecureErro><ErroAcesso /></SecureErro>} exact />
            <Route path="/Main" element={<SecureRotas><Main /></SecureRotas>} exact />
            <Route path="/Pedidos" element={<SecureRotas><Pedidos/></SecureRotas>} exact />
            <Route path="/DetPedido" element={<SecureRotas><DetPedido /></SecureRotas>} exact />
            <Route path="/Financeiro" element={<SecureRotas><Financeiro /></SecureRotas>} exact />
            <Route path="/Contatos" element={<SecureRotas><Contatos/></SecureRotas>} exact />
            <Route path="/Dados" element={<SecureRotas><Empresa/></SecureRotas>} exact />
            <Route path="/Avaliacao" element={<SecureRotas><Avaliacao/></SecureRotas>} exact />
            <Route path="/Assistencia" element={<SecureRotas><Assistencia/></SecureRotas>} exact />
            <Route path="/DetAssistencia" element={<SecureRotas><DetAssistencias/></SecureRotas>} exact />
            <Route path="/NewPed" element={<SecureRotas><NewPedido/></SecureRotas>} exact />

            <Route path="/catalogo" element={<SecureRotas><HomeCatalogo/></SecureRotas>} exact />
            <Route path="/catalogo/menu" element={<SecureRotas><MenuCatalogo/></SecureRotas>} exact />
            <Route path="/catalogo/produto" element={<SecureRotas><ProdutosCatalogo/></SecureRotas>} exact />
         </Routes>
      </HashRouter>
   )
}


export default Rotas;